import { Input } from "antd";
import { FormGrid } from "components/UI/Form/FormGrid";
import { usePaldockTranslation } from "hooks/usePaldockTranslation";
import { FC } from "react";
import { Control } from "react-hook-form";
import { FormItem } from "react-hook-form-antd";

import { FormDesignGeneralFormData } from "./formSchema";

import FormData = App.Data.FormData;

interface FormSettingComponentProps {
    formData: FormData;
    control: Control<FormDesignGeneralFormData>;
    fieldNames: {
        [K in keyof FormDesignGeneralFormData]: {
            name: K;
        };
    };
}
export const FormSettingComponent: FC<FormSettingComponentProps> = ({ control, fieldNames }) => {
    const { t } = usePaldockTranslation("forms.form-design-general");

    return (
        <>
            <FormGrid cols={2}>
                <FormItem
                    control={control}
                    name={fieldNames.show_timer_on_seconds?.name || "show_timer_on_seconds"}
                    label={t("fields.show_timer_on_seconds.label")}
                >
                    <Input placeholder={t("fields.show_timer_on_seconds.placeholder")} />
                </FormItem>
                <FormItem
                    control={control}
                    name={fieldNames.header_text?.name || "header_text"}
                    label={t("fields.header_text.label")}
                >
                    <Input placeholder={t("fields.header_text.placeholder")} />
                </FormItem>
            </FormGrid>
            <FormGrid cols={2}>
                <FormItem
                    control={control}
                    name={fieldNames.get_money_text?.name || "get_money_text"}
                    label={t("fields.get_money_text.label")}
                >
                    <Input placeholder={t("fields.get_money_text.placeholder")} />
                </FormItem>
                <FormItem
                    control={control}
                    name={fieldNames.meta_title?.name || "meta_title"}
                    label={t("fields.meta_title.label")}
                >
                    <Input placeholder={t("fields.meta_title.placeholder")} />
                </FormItem>
            </FormGrid>
            <FormGrid cols={2}>
                <FormItem
                    control={control}
                    name={fieldNames.meta_description?.name || "meta_description"}
                    label={t("fields.meta_description.label")}
                >
                    <Input placeholder={t("fields.meta_description.placeholder")} />
                </FormItem>
                <FormItem
                    control={control}
                    name={fieldNames.text_under_submit?.name || "text_under_submit"}
                    label={t("fields.text_under_submit.label")}
                >
                    <Input placeholder={t("fields.text_under_submit.placeholder")} />
                </FormItem>
            </FormGrid>
        </>
    );
};
